import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FORM_REFS } from '../../constants';
import { aemHostClient, eapiClient } from '../../restClient';
import { Translations } from '../../utils';

// child component
import Dynamicform from '../common/Dynamicform/dynamicForm';

// actions
import { blockUi, unBlockUi } from '../../actions/actionCreator';
import { logInUser } from '../../actions/auth';

import { setLanguageFlag, setTranslatedData } from '../layouts/actions/actionCreator';
// style
import axios from 'axios';
import './staff-login.css';

class StaffLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.config !== nextProps.config && nextProps.config.urls && nextProps.config.options && this.props.history.location.pathname === '/staff-login') {
      this.props.blockUi()
      this.dspLogin(nextProps.config);
    }
  }

  dspLogin = async (config) => {
    this.props.blockUi()
    const { urls = {}, options = {}, env } = config
    const { OPENAM_BASE_URI, STAFF_DSP_API_URL } = urls
    const authOptions = {
      url: OPENAM_BASE_URI + STAFF_DSP_API_URL,
      method: 'post',
      withCredentials: true,
      crossDomain: true,
      dataType: 'json',
      headers: { ...options }
    };

    axios(authOptions)
      .then(({ data, status, headers }) => {
        if (status === 200) {
          if (data.tokenId !== undefined) {
            const openAMToken = data.tokenId;
            this.props.blockUi()
            this.onFormSubmit(openAMToken)
          }
          else if (data.callbacks !== undefined && (env === 'dev' || env === 'uat')) {
            this.props.unBlockUi()
            this.props.history.push(this.state.from || '/sit-login');
          }
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }

  getFormData = (formData) => {
    this.setState({ formData });
  }

  onFormSubmit = (data) => {
    var payLoad = {};
    payLoad.token = data
    eapiClient("/users/role", {
      method: 'POST',
      timeout: 30000,
      withCredentials: true,
      credentials: 'same-origin',
      data: JSON.stringify(payLoad)
    })
      .then(({ data, status, headers }) => {
        if (status === 200) {
          const token = headers["x-hsbc-e2e-trust"];
          this.props.logInUser(true, token, '', data.responseData.principal, new Date(), '/case-list');
          aemHostClient('/aemData/formData/json_en-gb')
            .then(({ data }) => {
              this.props.setTranslatedData(data)
              this.props.unBlockUi()
              this.props.history.push(this.state.from || '/case-list');
            });

        }
      });
  }


  renderFormGroups() {
    let formData = {};
    const properties = {
      formData,
      editType: 'staff-login',
      pathname: this.props.history.location.pathname
    };
    if (this.state.formJson !== undefined && this.state.formJson.par !== undefined && this.state.formJson.par.aemform_staffLoginForm !== undefined) {
      return (
        <Dynamicform
          properties={properties}
          url={FORM_REFS[this.state.formJson.par.aemform_staffLoginForm.formRef]}
          getFormData={this.getFormData}
          disableSubmitOnClick={false}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
        />
      );
    }
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render() {
    const pageTitle = this.state.formJson ? this.state.formJson.par.page_title_mainTitle.pageHeading : '';
    document.title = `${this.translations(pageTitle)} - ${'HSBC GLCM'}`
    return (
      <div className="gdoc-staff-login">
        <div className="gdoc-staff-login-child">
          <div className="form-container">
            <div className="form-title">
              <h2 className="form-heading">
                {
                  this.translations(pageTitle)
                }
              </h2>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => {
  return {
    lang: state.lang,
    config: state.config
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logInUser: (...args) => {
      dispatch(logInUser(...args));
    },
    setTranslatedData: translatedData => {
      dispatch(setTranslatedData(translatedData))
    },
    setLanguageFlag: flag => {
      dispatch(setLanguageFlag(flag));
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StaffLogin);



// WEBPACK FOOTER //
// ./src/components/Login/StaffLogin.js